import {
    TRADE_IN_AEM_RESET_RESOLVE_ITEMS,
    TRADE_IN_AEM_ADD_RESOLVE_ITEM,
    TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS,
    TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_VALUE,
    TRADE_IN_AEM_SELECT_RESOLVE_ITEM,
    TRADE_IN_AEM_SET_RESOLVE_LOADING,
    TRADE_IN_AEM_SET_RESOLVE_VEHICLE,
    type TradeInAemFindVehicleActionsType,
    TRADE_IN_AEM_SET_RESOLVE_FAILED,
} from "../actions/TradeInAemFindVehicleActions";
import {
    type TradeInAemFindVehicleStatus,
    TradeInAemResolveItemType,
    type TradeInAemResolveItemConfig,
    type TradeInAemResolveVehicleType,
    type TradeInAemVehicleType,
} from "../../utils/types";
import { TradeInAemSearchType } from "../../utils/constants";

export type TradeInAemFindVehicleReducerType = {
    searchType: TradeInAemSearchType;
    /** Do not use this value for country specifc logic. Use vehiclePlateOrVinSelector from the CSL instead. */
    searchValue: string;
    searchResults: TradeInAemVehicleType[];
    searchStatus: TradeInAemFindVehicleStatus | undefined;
    resolveVehicle: TradeInAemResolveVehicleType;
    resolveLoading: boolean;
    resolveForm: TradeInAemResolveItemConfig[];
    resolveFailed: boolean;
};

export const initialStateTradeInAemFindVehicle: TradeInAemFindVehicleReducerType = {
    searchType: TradeInAemSearchType.LicensePlate,
    searchValue: "",
    searchResults: [],
    searchStatus: undefined,
    resolveVehicle: {},
    resolveLoading: false,
    resolveForm: [],
    resolveFailed: false,
};

const TradeInAemFindVehicleReducer = (
    state: TradeInAemFindVehicleReducerType = initialStateTradeInAemFindVehicle,
    action: TradeInAemFindVehicleActionsType,
): TradeInAemFindVehicleReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_RESULTS: {
            const { searchResults, status } = action;
            return {
                ...state,
                searchResults,
                searchStatus: status,
            };
        }

        case TRADE_IN_AEM_FIND_VEHICLE_SET_SEARCH_VALUE: {
            const { searchType, searchValue } = action;
            return { ...state, searchValue, searchType };
        }

        case TRADE_IN_AEM_SET_RESOLVE_VEHICLE: {
            return { ...state, resolveVehicle: action.resolveVehicle };
        }

        case TRADE_IN_AEM_SET_RESOLVE_LOADING: {
            return { ...state, resolveLoading: action.loading };
        }

        case TRADE_IN_AEM_SET_RESOLVE_FAILED: {
            const { failed } = action;
            return { ...state, resolveFailed: failed };
        }

        case TRADE_IN_AEM_ADD_RESOLVE_ITEM: {
            const { item } = action;
            // Replace the item if it already exists.
            // If this causes bugs CSL needs to catch edge cases before they are added to the store.
            const foundItem = state.resolveForm.findIndex(
                (formItem) => formItem.vehicleProperty === item.vehicleProperty,
            );

            if (foundItem !== -1) {
                state.resolveForm[foundItem] = item;
                return { ...state, resolveForm: [...state.resolveForm] };
            }

            // Input fields in resolve should always be placed first.
            if (item.type === TradeInAemResolveItemType.Input) {
                const { resolveForm } = state;
                resolveForm.unshift(item);
                return { ...state, resolveForm };
            }

            return { ...state, resolveForm: [...state.resolveForm, item] };
        }

        case TRADE_IN_AEM_SELECT_RESOLVE_ITEM: {
            const { itemKey, optionId } = action;

            const foundItem = state.resolveForm.findIndex((formItem) => formItem.vehicleProperty === itemKey);

            if (foundItem !== -1) {
                state.resolveForm[foundItem] = { ...state.resolveForm[foundItem], selectedOptionId: optionId };
                return { ...state, resolveForm: [...state.resolveForm] };
            }

            return { ...state };
        }

        case TRADE_IN_AEM_RESET_RESOLVE_ITEMS: {
            const { itemKeys } = action;

            const updatedForm = state.resolveForm.filter((formItem) => itemKeys.includes(formItem.vehicleProperty));
            const updatedVehicle = Object.fromEntries(
                Object.entries(state.resolveVehicle).filter(([key]) => itemKeys.includes(key)),
            );
            return { ...state, resolveForm: updatedForm, resolveVehicle: updatedVehicle };
        }

        default:
            return state;
    }
};

export default TradeInAemFindVehicleReducer;
